import { Button, Box, TextField } from "@mui/material";
import React from "react";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";

export default function NrCrew(props) {
  console.log("NrCrew", props);
  let { preferences, trip_type } = props;
  const uniquePreferences =
    !preferences || !Array.isArray(preferences) || preferences.length === 0
      ? []
      : [
          ...preferences
            .reduce((crew, obj) => crew.set(obj.crew, obj), new Map())
            .values(),
        ];

  return (
    <Box mt={0} width="100%" align="center">
      <h2 className="sectionTitle center">Number of Crew</h2>
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid item xs={12} md="auto">
          <Box display="flex" flexWrap="wrap" justifyContent="center">
            {uniquePreferences.map(
              (trip, idx) =>
                trip_type === trip.tripcatg && (
                  <Box m={0.5} key={idx}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className="form-input"
                      data-new-value={trip.crew}
                      data-field={"number_of_crew"}
                      size="large"
                      onClick={(e) =>
                        props.handleTripPreferenceChange(e, trip.crew)
                      }
                      key={trip.crew + trip.tripcatg}
                    >
                      {trip.crew}
                    </Button>
                  </Box>
                )
            )}
          </Box>
        </Grid>

        <Grid item xs={12} md="auto">
          <FormControl>
            <TextField
              variant="standard"
              label="Number of Crew:"
              className="number-of-input"
              inputProps={{ min: 0, style: { textAlign: "center" } }}
              value={props.number_of_crew ? Number(props.number_of_crew) : ""}
              name="number_of_crew"
              type="number"
              min="0"
              max="999"
              onChange={(e) => props.handleInputChange(e)}
              helperText="Must be greater than zero"
            />
          </FormControl>
          <HelpText helpText={getHelpText(props.helpText, "num_crew")} />
        </Grid>
      </Grid>
    </Box>
  );
}
